<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

useBackButton();

const viewModel = await useViewModelInstance();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Locked out of your car?</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <p>
                Being locked out of your car can be frustrating. Here's a guide to help you navigate the situation:
            </p>

            <p>
                <span class="dark:text-white">Take a Deep Breath:</span>
                If you can't find a spare key, call a friend or family member who might have a spare or who can lend a hand. 
                Bonus points if they bring snacks or entertainment while you wait.
            </p>

            <div v-if="viewModel.carePlan.roadsideAssistance.isEnabled">
                <p>
                    <span class="dark:text-white">Call for Professional Help:</span>
                    If all else fails, it might be time to call your Roadside Assist provider. 
                    While you wait, you can use the time to practice your storytelling skills or 
                    come up with creative excuses for being late. Don't have a Roadside Assist provider? 
                    Not to worry, Carbucks has partnered with Roadside Assist providers that will be able 
                    to assist even if you aren't a member.
                </p>

                <div class="flex justify-center py-4">
                    <RoadsideAssistanceButton /> 
                </div>
            </div>

        </div>

    </div>   
    
</template>
